import { render } from "./numericpad.vue?vue&type=template&id=6f1c0a58"
import script from "./numericpad.vue?vue&type=script&lang=js"
export * from "./numericpad.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__